import {
  base_colorSurfaceMuted,
  base_contentBackground,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_regular, font_xs } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export interface LayoutShellStyleProps {
  fixedElementPushdown: number
  rightShift: string
}

export default css<LayoutShellStyleProps>`
  &.LayoutPage {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    transition:
      width 0.3s ease,
      max-width 0.3s ease;

    gap: ${spacing(6)};
    &.with-subnav {
      gap: ${spacing(2)};
    }

    /* padding sizes */

    &.small {
      padding: ${spacing(6)};
    }

    &.medium {
      padding: ${spacing(12)};
    }

    /* background colors */

    &.gray {
      background-color: ${base_colorSurfaceMuted};
    }

    &.white {
      background-color: ${base_contentBackground};
    }

    /* Dynamic positioning based on props */
    top: ${(props) => props.fixedElementPushdown}px;
    width: calc(100% - ${(props) => props.rightShift});

    /* Fixed height mode for independent scrolling */
    &.fixed-height {
      height: calc(100vh - ${(props) => props.fixedElementPushdown}px - 72px);
      max-height: calc(
        100vh - ${(props) => props.fixedElementPushdown}px - 72px
      );
      overflow: hidden;
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: ${spacing(4)};
      min-height: 40px;
    }

    .title-section {
      display: flex;
      flex-direction: column;
      gap: ${spacing(2)};
      flex: 1;
    }

    .subtitle {
      font-family: ${font_family_weight_regular};
      ${font_xs};
      color: ${text_colorTextSecondary};
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: ${spacing(3)};
      flex: 1;
      overflow: hidden;
    }
  }
`
